var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 15.1667C11.958 15.1667 15.1667 11.958 15.1667 8C15.1667 4.04196 11.958 0.833334 7.99999 0.833334C4.04195 0.833334 0.833326 4.04196 0.833326 8C0.833326 11.958 4.04195 15.1667 7.99999 15.1667Z",
    stroke: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88868 9C7.88868 7.75 8.93935 7.54081 9.30114 7.20247C9.6641 6.86303 9.88868 6.3936 9.88868 5.875C9.88868 4.83947 8.99325 4 7.88868 4C7.2914 4 6.75528 4.24545 6.38881 4.63464C6.21936 4.81459 6.08618 5.02527 6 5.25663",
    stroke: "#1F1F1F",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8887 11.5C8.25689 11.5 8.55537 11.2202 8.55537 10.875C8.55537 10.5298 8.25689 10.25 7.8887 10.25C7.52051 10.25 7.22203 10.5298 7.22203 10.875C7.22203 11.2202 7.52051 11.5 7.8887 11.5Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.f02059be.svg";
export { ForwardRef as ReactComponent };